import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../utils/whatsapp';

export const FloatingContactButtons = () => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    let promptTimer;
    let collapseTimer;
    const alreadyPrompted = window.sessionStorage.getItem('bizsarthi-whatsapp-prompted') === '1';
    if (!alreadyPrompted) {
      promptTimer = window.setTimeout(() => {
        setVisible(true);
        setExpanded(true);
        window.sessionStorage.setItem('bizsarthi-whatsapp-prompted', '1');
        collapseTimer = window.setTimeout(() => setExpanded(false), 8000);
      }, 1800);
    }
    const updateVisibility = () => {
      if (window.scrollY > 520) setVisible(true);
    };
    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.clearTimeout(promptTimer);
      window.clearTimeout(collapseTimer);
    };
  }, []);

  return (
    <div className={`fixed bottom-7 right-6 z-50 hidden transition-all duration-300 lg:block ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'}`}>
      <button
        onClick={() => openWhatsApp()}
        className="group flex h-14 items-center justify-center gap-0 overflow-hidden rounded-full bg-emerald-600 px-4 text-white shadow-[0_18px_45px_-18px_rgba(5,150,105,0.9)] transition-all hover:-translate-y-1 hover:bg-emerald-700 hover:px-5"
        title="WhatsApp Us"
        aria-label="Chat with BizSarthi on WhatsApp"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle className="h-5 w-5 shrink-0" />
        <span className={`overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:ml-2 group-hover:max-w-32 group-hover:opacity-100 ${expanded ? 'ml-2 max-w-32 opacity-100' : 'ml-0 max-w-0 opacity-0'}`}>Ask BizSarthi</span>
      </button>
    </div>
  );
};
